import { call, takeLatest, put } from "redux-saga/effects";
import {
  getAcquiredVehiclePage,
  getAcquiredVehicleList,
} from "network/services/acquiredAssets";
import {
  getAcquiredVehiclePageDataFailed,
  getAcquiredVehiclePageDataSuccess,
} from "../actionCreators";
import { ISaga, AutoLoansData } from "../types";
const carDetailsArray = [
  {
    field_car_image:
      "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&width=1200",
    field_carmodel: "Vios",
    field_color: "black",
    field_fuel_type: "Diesel",
    field_item_no_: "11",
    field_maker: "Toyota",
    field_plate_no_: "ABC 111",
    field_mileage: "11111",
    field_model_year: "2010",
    field_number_coding: "1 & 2 (Monday)",
    field_price: "1,500,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "TOYOTA VIOS 2010",
  },
  {
    field_car_image: "https://example.com/car2.jpg",
    field_carmodel: "Corolla",
    field_color: "blue",
    field_fuel_type: "Petrol",
    field_item_no_: "22",
    field_maker: "Toyota",
    field_plate_no_: "XYZ 222",
    field_mileage: "22222",
    field_model_year: "2015",
    field_number_coding: "3 & 4 (Tuesday)",
    field_price: "1,800,000",
    field_transmission: "Manual",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "TOYOTA COROLLA 2015",
  },
  {
    field_car_image: "https://example.com/car3.jpg",
    field_carmodel: "Civic",
    field_color: "red",
    field_fuel_type: "Gasoline",
    field_item_no_: "33",
    field_maker: "Honda",
    field_plate_no_: "LMN 333",
    field_mileage: "33333",
    field_model_year: "2018",
    field_number_coding: "5 & 6 (Wednesday)",
    field_price: "2,200,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "HONDA CIVIC 2018",
  },
  {
    field_car_image: "https://example.com/car4.jpg",
    field_carmodel: "Accord",
    field_color: "silver",
    field_fuel_type: "Petrol",
    field_item_no_: "44",
    field_maker: "Honda",
    field_plate_no_: "PQR 444",
    field_mileage: "44444",
    field_model_year: "2017",
    field_number_coding: "7 & 8 (Thursday)",
    field_price: "2,400,000",
    field_transmission: "CVT",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "HONDA ACCORD 2017",
  },
  {
    field_car_image: "https://example.com/car5.jpg",
    field_carmodel: "Camry",
    field_color: "white",
    field_fuel_type: "Hybrid",
    field_item_no_: "55",
    field_maker: "Toyota",
    field_plate_no_: "STU 555",
    field_mileage: "55555",
    field_model_year: "2022",
    field_number_coding: "9 & 0 (Friday)",
    field_price: "2,800,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "TOYOTA CAMRY 2022",
  },
  {
    field_car_image: "https://example.com/car6.jpg",
    field_carmodel: "Mazda3",
    field_color: "gray",
    field_fuel_type: "Gasoline",
    field_item_no_: "66",
    field_maker: "Mazda",
    field_plate_no_: "VWX 666",
    field_mileage: "66666",
    field_model_year: "2019",
    field_number_coding: "1 & 2 (Monday)",
    field_price: "2,100,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "MAZDA3 2019",
  },
  {
    field_car_image: "https://example.com/car7.jpg",
    field_carmodel: "Sentra",
    field_color: "black",
    field_fuel_type: "Petrol",
    field_item_no_: "77",
    field_maker: "Nissan",
    field_plate_no_: "YZA 777",
    field_mileage: "77777",
    field_model_year: "2021",
    field_number_coding: "3 & 4 (Tuesday)",
    field_price: "1,900,000",
    field_transmission: "CVT",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "NISSAN SENTRA 2021",
  },
  {
    field_car_image: "https://example.com/car8.jpg",
    field_carmodel: "Civic",
    field_color: "blue",
    field_fuel_type: "Gasoline",
    field_item_no_: "88",
    field_maker: "Honda",
    field_plate_no_: "BCD 888",
    field_mileage: "88888",
    field_model_year: "2020",
    field_number_coding: "5 & 6 (Wednesday)",
    field_price: "2,300,000",
    field_transmission: "Manual",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "HONDA CIVIC 2020",
  },
  {
    field_car_image: "https://example.com/car9.jpg",
    field_carmodel: "Focus",
    field_color: "red",
    field_fuel_type: "Gasoline",
    field_item_no_: "99",
    field_maker: "Ford",
    field_plate_no_: "EFG 999",
    field_mileage: "99999",
    field_model_year: "2016",
    field_number_coding: "7 & 8 (Thursday)",
    field_price: "2,000,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "FORD FOCUS 2016",
  },
  {
    field_car_image: "https://example.com/car10.jpg",
    field_carmodel: "Altima",
    field_color: "silver",
    field_fuel_type: "Petrol",
    field_item_no_: "1010",
    field_maker: "Nissan",
    field_plate_no_: "HIJ 1010",
    field_mileage: "101010",
    field_model_year: "2014",
    field_number_coding: "9 & 0 (Friday)",
    field_price: "1,700,000",
    field_transmission: "CVT",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "NISSAN ALTIMA 2014",
  },
  {
    field_car_image: "https://example.com/car11.jpg",
    field_carmodel: "Sonata",
    field_color: "white",
    field_fuel_type: "Hybrid",
    field_item_no_: "1111",
    field_maker: "Hyundai",
    field_plate_no_: "KLM 1111",
    field_mileage: "111111",
    field_model_year: "2023",
    field_number_coding: "1 & 2 (Monday)",
    field_price: "2,500,000",
    field_transmission: "Automatic",
    field_warehouse_location: "NCR (Metro Manila)",
    title: "HYUNDAI SONATA 2023",
  },
];

function* processAcquiredVehicles(): ISaga {
  try {
    const { data: acquiredVehiclesPage } = yield call(getAcquiredVehiclePage);
    const { data: list } = yield call(getAcquiredVehicleList);
    const payload: AutoLoansData = {
      page: acquiredVehiclesPage,
      list: carDetailsArray,
    };

    yield put(getAcquiredVehiclePageDataSuccess(payload));
  } catch (error) {
    yield put(getAcquiredVehiclePageDataFailed());
  }
}

export default function* watcher() {
  yield takeLatest(
    "REQUEST_ACQUIRED_VEHICLES_RATES_DATA",
    processAcquiredVehicles
  );
}
